var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBluePlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.001,
    height: 10,
    viewBox: "0 0 10.001 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(-52 -720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M-243.555,1824.444v-3.889h-3.889A.556.556,0,0,1-248,1820a.556.556,0,0,1,.556-.555h3.889v-3.889A.555.555,0,0,1-243,1815a.555.555,0,0,1,.555.555v3.889h3.889A.556.556,0,0,1-238,1820a.556.556,0,0,1-.556.555h-3.889v3.889A.556.556,0,0,1-243,1825,.556.556,0,0,1-243.555,1824.444Z",
    transform: "translate(300 -1095)",
    fill: "#265df5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBluePlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BluePlus.6b4dc817302af56b915576451320bdd0.svg";